import { useTranslation } from 'react-i18next';
import styles from './delete-related-product-dialog.module.scss';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, SecondaryButton, Typography } from '@frontend-workspace/react-shared-lib';

/* eslint-disable-next-line */
export interface DeleteRelatedProductDialogProps {
  open: boolean,
  onClose: () => void,
  deleteRelatedProduct?: any
}

export function DeleteRelatedProductDialog(props: DeleteRelatedProductDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth='sm'>
      <DialogTitle className='mb-3'>
        {t("standard.areYouSureYouWantToDelete")}
        {/* {JSON.stringify(deleteProduct?.groupName)} */}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'>
          {/* Undermodul: {deleteProduct?.productName} */}
        </Typography>
      </DialogContent>
      <DialogActions>
        <SecondaryButton
          variant="contained"
          size='large'
          // onClick={}
          className='minButtonWidth'>
          {t("standard.deleteProduct")}
        </SecondaryButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t("standard.cancel")}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteRelatedProductDialog;